export const handleSelectAndScrollFocus = (
  event: React.FocusEvent<HTMLInputElement>,
  selectOnFocus: boolean,
  allowScroll: boolean,
) => {
  const input = event.currentTarget;
  if (selectOnFocus) {
    input.select();
  }
  if (allowScroll) {
    const root = input.closest("[data-field-root]");

    const element = root || input;

    // scroll into view doesnt work on selects on iphone without a timeout
    setTimeout(
      () =>
        element.scrollIntoView({
          behavior: "smooth",
          block: "center",
          inline: "nearest",
        }),
      100,
    );
  }
};
